(function () {
    const header = document.querySelector('.header')

    if (header) {
        document.addEventListener('scroll', () => {
            document.body.scrollTop > 0 || document.documentElement.scrollTop > 0 ?
                header.classList.add('header_shrink') :
                header.classList.remove('header_shrink')
        }, {
            passive: true
        })
    }
}());

(function () {
    const headerBurger = document.querySelector('[data-aside-open]')
    const headerBurgerAside = document.querySelector('[data-aside-close]')
    const headerAside = document.querySelector('[data-aside]')
    const headerAsideWrap = document.querySelector('[data-aside-wrap]')

    const asideAction = () => headerAside.classList.toggle('active')

    if (headerBurger && headerBurgerAside) {
        headerBurger.addEventListener('click', () => asideAction())
        headerBurgerAside.addEventListener('click', () => asideAction())

        headerAside.addEventListener('click', (e) => {
            if (!headerAsideWrap.contains(e.target)) asideAction()
        })
    }
}());
